export default __webpack_public_path__ + "static/media/eye-solid.e6b2851a.svg";